/**
 * PhaseNavigationItem
 */
import React from 'react';
import { Icon } from 'ui-component-library/base';
import { Link as LinkBase } from 'ui-component-library/base';
/** Link item for navigation to next/previous phase. */
var PhaseNavigationItem = function (_a) {
    var name = _a.name, url = _a.url, type = _a.type, label = _a.label, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h2' : _c;
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("li", { className: "mb-6", "data-cid": "PhaseNavigationItem" },
        type === 'next' && (React.createElement(Heading, { className: "ml-8 font-bold text-h5" }, label)),
        type === 'previous' && (React.createElement(Heading, { className: "ml-8 font-bold text-h5" }, label)),
        React.createElement(Link, { className: "text-xl text-teal hover:underline", to: url, "data-cid": type === 'next'
                ? 'PhaseNavigationLinkNext'
                : 'PhaseNavigationLinkPrev' },
            React.createElement("span", { className: "inline-block w-8" },
                React.createElement(Icon, { icon: "arrow", "aria-hidden": "true", className: "text-teal", direction: type === 'next' ? 'right' : 'left' })),
            name)));
};
export default PhaseNavigationItem;
